// Same as HubStyleTokens GridBreakpointSmall
export const ROW_BREAKPOINT = 544;

export const LEFT_GRID_SIZE = { xs: 7, md: 8 } as const;
export const RIGHT_GRID_SIZE = { xs: 5, md: 4 } as const;
